export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'left',
    fixed: 'left',
    width: 110,
    slots: {
      default: 'opt',
    },
  },
  {
    field: 'importTemplateNo',
    align: 'left',
    minWidth: 160,
    title: '模板编号',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'importTemplateType',
    align: 'left',
    minWidth: 160,
    title: '模板类型',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'importTemplateName',
    align: 'left',
    minWidth: 250,
    title: '导入模板名称',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'importTemplateFileName',
    align: 'left',
    minWidth: 200,
    title: '模板文件原始名称',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'excelMatchingMethod',
    align: 'left',
    width: 180,
    title: 'excel文件字段匹配方式',
    sortable: true,
    sortType: 'number',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'startRow',
    align: 'left',
    width: 180,
    title: '字段列匹配模式',
    sortable: true,
    sortType: 'number',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'ifRepeatMethod',
    align: 'left',
    width: 180,
    title: '导入重复记录处理方式',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  // {
  //   field: 'importTemplateFileUrl',
  //   align: 'left',
  //   minWidth: 200,
  //   title: '模板文件Url地址',
  // },
  // {
  //   field: 'importTemplateLocalPath',
  //   align: 'left',
  //   minWidth: 200,
  //   title: '模板文件本地路径',
  // },
  {
    align: 'left',
    width: 100,
    title: '状态',
    slots: { default: 'status' },
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'createByName',
    sortable: true,
    width: 100,
    title: '创建人',
    align: 'left',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'createTime',
    sortable: true,
    width: 170,
    title: '创建时间',
    align: 'left',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'modifyByName',
    sortable: true,
    width: 100,
    title: '修改人',
    align: 'left',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'modifyTime',
    sortable: true,
    width: 170,
    title: '修改时间',
    align: 'left',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
]
